{
  "title": "Globe of Invulnerability",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level abjuration",
  "level": 6,
  "castingTime": "1 action",
  "range": "Self (10-foot radius)",
  "components": "V, S, M (a glass or crystal bead that shatters when the spell ends)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "An immobile, faintly shimmering barrier springs into existence in a 10-foot radius around you and remains for the duration.",
    "Any spell of 5th level or lower cast from outside the barrier can’t affect creatures or objects within it, even if the spell is cast using a higher level spell slot. Such a spell can target creatures and objects within the barrier, but the spell has no effect on them. Similarly, the area within the barrier is excluded from the areas affected by such spells.",
    "At Higher Levels. When you cast this spell using a spell slot of 7th level or higher, the barrier blocks spells of one level higher for each slot level above 6th."
  ],
  "spellLists": ["sorcerer", "wizard"]
}
